import React from 'react';

import './LiveMatchRowSkeleton.scss';

// Shaped like a real LiveMatchRow (thumbs + text lines) at the same fixed height, so loading reads
// as content arriving and day switches never collapse the layout.
const LiveMatchRowSkeleton = () => (
  <div className='live-match-row-skeleton' aria-hidden='true'>
    <div className='sk-thumb' />
    <div className='sk-lines'>
      <div className='sk-line' />
      <div className='sk-line short' />
    </div>
    <div className='sk-thumb' />
    <div className='sk-lines'>
      <div className='sk-line' />
      <div className='sk-line short' />
    </div>
  </div>
);

export default LiveMatchRowSkeleton;
